// extracted by mini-css-extract-plugin
module.exports = {"player":"VideoPlayer_player__auGme","vjsFullscreen":"VideoPlayer_vjs-fullscreen__35EaL"};